export const ADDRESSES_CONTACTS_AREA = {
  LABEL: 'personal.addresses_contacts',
  ADDRESS: 'dbf9e928-2e39-4583-9ebe-ef14b5094eb4',
  CONTACTS: '796453df-01ed-40bb-9364-7b6f272f803e',
  EMERGENCY_CONTACTS: '608527f9-5469-44ef-b246-54609f0d4c09'
}
